/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import Header from "components/common_components/Header";
import LoadingPage from "components/common_components/LoadingPage";
import Page from "components/common_components/Page";
import FormsContext from "./FormsContext";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import { removeDuplicates } from "utils/arrays";
import CategoriesContainer from "./components/Categories";
import FormsContainer from "./components/Forms";
import ClientsContainer from "./components/Clients";
import ComfirmationContainer from "./components/Comfirmation";
import clsx from "clsx";

const AddWizard = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [resources, setResources] = useState({
        forms: [],
        categories: [],
    });
    const [isLoading, setIsLoading] = useState(false);
    const [form, setForm] = useState(null);
    const [category, setCategory] = useState(null);
    const [client, setClient] = useState(null);
    const [filteredForms, setFilteredForms] = useState([]);
    const [categoriesContainerVisible, setCategoriesContainerVisible] = useState(true);
    const [formsContainerVisible, setFormsContainerVisible] = useState(false);
    const [clientsContainerVisible, setClientsContainerVisible] = useState(false);
    const [comfirmationContainerVisible, setComfirmationContainerVisible] = useState(false);

    const { Forms, setAddFormState } = useContext(FormsContext);

    const getResources = () => {
        setIsLoading(true);
        Forms.getAll({
            onSuccess: (forms) => {
                const categories = forms.map((form) => form.category);
                setResources((prev) => ({
                    ...prev,
                    forms,
                    categories: removeDuplicates(categories),
                }));
                setIsLoading(false);
            },
            onError: (error) => {
                setResources((prev) => ({ ...prev, forms: [] }));
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getResources();
    }, []);

    useEffect(() => {
        if (category) {
            setFormsContainerVisible(true);
            setCategoriesContainerVisible(false);
            const formsByCategory = resources.forms.filter((form) => form.category === category);
            setFilteredForms(formsByCategory);
        } else {
            setFormsContainerVisible(false);
            setClientsContainerVisible(false);
            setCategoriesContainerVisible(true);
            setFilteredForms([]);
        }
    }, [category, resources.forms]);

    useEffect(() => {
        if (form) {
            setClientsContainerVisible(true);
        } else {
            setClientsContainerVisible(false);
        }
    }, [form]);

    useEffect(() => {
        if (client) {
            setFormsContainerVisible(false);
            setClientsContainerVisible(false);
            setComfirmationContainerVisible(true);
        } else {
            setFormsContainerVisible(true);
            setClientsContainerVisible(true);
            setComfirmationContainerVisible(false);
        }
    }, [client]);

    const onFormsBackClick = () => {
        setCategory(null);
        setForm(null);
    };

    const onComfirm = () => {
        setAddFormState({
            category,
            form,
            client,
        });
        history.push("/forms/add");
    };

    return (
        <Page className="add-form-wizard-page">
            <Header title="Create form" />
            {isLoading && <LoadingPage />}
            {!isLoading && (
                <div
                    className={clsx("container", {
                        "in-comfirmation": comfirmationContainerVisible,
                    })}
                >
                    <CategoriesContainer
                        categories={resources.categories}
                        visible={categoriesContainerVisible}
                        onClick={setCategory}
                        onBackClick={history.goBack}
                    />
                    <FormsContainer
                        forms={filteredForms}
                        category={category}
                        visible={formsContainerVisible}
                        onClick={setForm}
                        onBackClick={onFormsBackClick}
                        selected={form}
                    />
                    <ClientsContainer
                        visible={clientsContainerVisible}
                        form={form}
                        onBackClick={() => setForm(null)}
                        onClientSelected={setClient}
                    />
                    <ComfirmationContainer
                        visible={comfirmationContainerVisible}
                        category={category}
                        form={form}
                        client={client}
                        onBackClick={() => setClient(null)}
                        onContinue={onComfirm}
                    />
                </div>
            )}
        </Page>
    );
};

export default AddWizard;
